import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M24 18l6-6-6-6m6 6H16C8.268 12 2 18.268 2 26" fill="none" />
  </Icon>
);
